import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import RCore from 'RCore';

const WDPWidgetPreview = ({ name, params, isVideo }) => {
    console.log(params, '->', RCore.obj2InjectorParams(params));
    return (
        <div>
            {name && (
                <rlz-widget
                    key={name + '_' + JSON.stringify(params)}
                    class="smi-widget"
                    data-load={'js'}
                    data-name={name}
                    data-token={'cb4bf29d'}
                    data-min-width={800}
                    data-min-height={350}
                    data-sm-browser
                    data-__mode="strict"
                    {...RCore.obj2InjectorParams(params)}
                />
            )}
        </div>
    );
};

WDPWidgetPreview.propTypes = {};

export default WDPWidgetPreview;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/WDPWidgetPreview.js
 **/